<nz-result nzStatus="403" nzTitle="Sorry, login failed" [nzSubTitle]="(error$ | async) ?? ''">
  <div nz-result-extra>
    <button [routerLink]="['/']" nz-button nzType="primary">Back Home</button>
  </div>
</nz-result>
